import { LogLevel } from '@shared/logger';
import { z } from 'zod';

/**
 * Parse and validate the configuration.
 *
 * Use `z.string()` to parse string values.
 * Use `z.coerce.number()` to parse number values.
 * Use `z.coerce.boolean()` to parse boolean values.
 */
export default z.object({
  mode: z.enum(['development', 'production', 'staging', 'uat']),
  logLevel: z.nativeEnum(LogLevel).default(LogLevel.INFO),
  graphql: z.object({
    apiUrl: z.string().min(1).url(),
    defaultFetchPolicy: z
      .enum(['cache-first', 'network-only', 'cache-only', 'no-cache', 'standby'])
      .optional(),
  }),
  loginUrl: z.string().min(1).url(),
  examRoom: z.object({
    previewUrl: z.string().min(1).url(),
  }),
  modules: z.object({
    userManagement: z.object({
      azureLoginUrl: z.string(),
      restrictedUserEmailDomains: z.string().transform((v) => {
        if (v === '') {
          return [];
        }
        return v.split(',').map((s) => s.trim());
      }),
      internalUserEmailDomains: z.string().transform((v) => {
        if (v === '') {
          return [];
        }
        return v.split(',').map((s) => s.trim());
      }),
    }),
    qcontent: z.object({
      singleImportTemplateUrl: z.string().url(),
      itemSetImportTemplateUrl: z.string().url(),
      maxSubQuestions: z.string().transform((v) => {
        const num = Number(v);
        if (isNaN(num)) {
          throw new Error('maxSubQuestions must be a number');
        }
        if (num < 1) {
          throw new Error('maxSubQuestions must be greater than 0');
        }
        return num;
      }),
    }),
  }),
  appShell: z.string().transform((v) => JSON.parse(v === '' ? '[]' : v)),
});
